import actions from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions';

export default () => ({
    state: {
        notificationTimeout: 4000,
        pathParams: {
            task: null,
            tool: null,
            location: null,
            variation: null,
        },
        sectionLoading: false,
        trackedErrors: [],
    },
    mutations: {
        CLEAR_PATH_PARAMS(state) {
            state.pathParams = {
                task: null,
                tool: null,
                location: null,
                variation: null,
            };
        },
        ADD_TRACKED_ERRORS(state, payload) {
            for (let i = 0; i < payload.length; i++) {
                if (state.trackedErrors.indexOf(payload[i]) === -1) {
                    state.trackedErrors.push(payload[i]);
                }
            }
        },
        REMOVE_TRACKED_ERRORS(state, payload) {
            for (let i = 0; i < payload.length; i++) {
                let index = state.trackedErrors.indexOf(payload[i]);
                if (index > -1) {
                    state.trackedErrors.splice(index, 1);
                }
            }
        },
        SET_PATH_PARAM(state, payload) {
            state.pathParams[payload.key] = payload.value;
        },
    },
    actions: {
        ...actions,
    },
});